import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewEncapsulation,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FormFieldConfig} from "../../../../../../model/api/form-field-config";
import {CommonFieldService} from "../../../../../../services/common/common-field.service";
import {AllocationRequest} from "../../../../../../model/clearing/allocation/allocation-request";
import {AccountType} from "../../../../../../model/exchange/account-type";
import {ClearingAllocationService} from "../../../../../../services/clearing/clearing-allocation.service";
import {SingleAllocationFormBaseComponent} from "../single-allocation-form-base.component";
import {AllocationSplitRequest} from "../../../../../../model/clearing/allocation/allocation-split-request";
import {ClearingSelectionInfo} from "../../../../../../model/clearing/clearing-selection-info";
import {AccountDefinition} from "../../../../../../model/customer/account-definition";
import {Customer} from "../../../../../../model/customer/customer";
import {ClearingTradeInfoService} from "../../../../../../services/clearing/clearing-trade-info.service";
import {ClearingInfoLoadRequest} from "../../../../../../model/clearing/clearing-info-load-request";
import {Observable} from "rxjs";
import {ApiValidation} from "../../../../../../model/api/api-validation";
import {ClearingSelectionSummary} from "../../../../../../model/clearing/clearing-selection-summary";
import {AppConfigService} from "../../../../../../services/app-config.service";
import {CcStorageService} from "../../../../../../services/common/cc-storage.service";
import {FieldsService} from "../../../../../../services/common/fields-service";
import TYPE = FormFieldConfig.TYPE;
import OpenClose = AccountDefinition.OpenClose;

@Component({
  selector: 'app-clearing-single-allocation-multi-exchange-form',
  templateUrl: './single-allocation-multi-exchange-form.component.html',
  styleUrls: ['../allocation-form-base.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SingleAllocationMultiExchangeFormComponent extends SingleAllocationFormBaseComponent {

  // clearingHouses: FieldRecord<ClearingHouse>[] = [];
  // significantTrades: Trade[] = [];

  constructor(el: ElementRef,
              cdref: ChangeDetectorRef,
              allocationService: ClearingAllocationService,
              commonFieldService: CommonFieldService,
              appConfigService: AppConfigService,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService,
              private clearingTradeInfoService: ClearingTradeInfoService,
              storageService: CcStorageService,
              fieldsService: FieldsService) {
    super(el, cdref, allocationService,
      commonFieldService, appConfigService, messageService, confirmationService, translateService, storageService,
      fieldsService);
    this.formRecord = new AllocationRequest();
    this.formRecord.accountTypeCode = AccountType.GIVE_UP_CODE;
  }

  // loadData() {
  //   super.loadData();
  //   // this.commonFieldService.getClearingHouses(FieldRequest.DEFAULT()).subscribe(fieldResult => {
  //   //   this.clearingHouses = this.getFields(fieldResult);
  //   //   this.loadingProgressValue += 100 / this.dataToLoadCount;
  //   // });
  // }

  protected initConfigs() {
    this.dialogFormTitle = this.getTranslation('page.' + this.transPartKey + '.table.single_allocation_multi_exchange');

    const exchangeFieldConfigs = [];

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'orderReference',
            // required: true,
            column: 2,
            type: TYPE.TEXT,
            input: (event, formRecord, inputField) => {
              var start = inputField.selectionStart;
              var end = inputField.selectionEnd;
              inputField.value = inputField.value.toUpperCase();
              formRecord.orderReference = inputField.value;
              inputField.setSelectionRange(start, end);
            },
          },
          {
            field: 'owner',
            // required: true,
            column: 2,
            optionValue: 'text',
            type: TYPE.DROPDOWN,
            options: () => this.owners,
            hidden: record => this.owners.length <= 1
          },
          {
            field: 'customerName',
            // required: true,
            filter: true,
            column: 2,
            type: TYPE.AUTOCOMPLETE,
            options: () => this.getDistinctOpts(this.displayedCustomers),
            changed: event => {
              this.formRecord.customerName = event.text;
              this.formRecord.customerId = event.id;
              this.formRecord.allocations.forEach(allocation => {
                allocation.customerName = event.text;
                allocation.customerId = event.id;
                allocation.accountCode = undefined;
                allocation.accountTypeCode = AccountType.GIVE_UP_CODE;
                allocation.giveupAccountType = undefined;
                allocation.executionFee = undefined;
                allocation.giveUpBrokerCode = undefined;
                allocation.giveUpCommission = undefined;
                allocation.giveUpMessage = undefined;
                allocation.giveUpMessage2 = undefined;
                allocation.giveUpMessage3 = undefined;
                allocation.broker = undefined;
                allocation.openClose = OpenClose.NO;
                allocation.reference1 = undefined;
                allocation.reference2 = undefined;
                allocation.reference3 = undefined;
                allocation.traderName = undefined;
              })
            }
          },
          {
            column: 2,
            type: TYPE.NONE,
            hidden: record => this.owners.length > 1
          },
          {
            column: 6,
            type: TYPE.NONE,
          },
          {
            field: 'allocations',
            // required: true,
            filter: true,
            column: 12,
            type: TYPE.ADDDELETEFIELD,
            // validate: record => this.validateSplits(record),
            richFieldConfig: {
              // canDelete: formRecords => this.canDeleteSplit(formRecords),
              // canAdd: formRecords => this.canAddSplit(formRecords),
              // addNew: formRecords => this.addSplit(formRecords),
              fieldId: 'is',
              fieldName: 'id',
              fields: exchangeFieldConfigs
            }
          }
        ]
      },
    ];

    exchangeFieldConfigs.push(
      {
        group: '',
        fields: [
          {
            // field: 'exchangeCode',
            // column: 1,
            // type: TYPE.TEXT,
            // disabled: () => true
            field: 'exchangeCode',
            column: 1,
            type: TYPE.NONE,
            icon: (id, record) => {
              const exchField = this.exchanges ? this.exchanges.find(field => field.value
                && field.value.clearingHouse === record.clearingHouse
                && field.value.code === record.exchangeCode) : undefined;
              if (exchField && exchField.value) {
                return exchField.value.country ? 'flag-icon-form flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
              } else {
                return '';
              }
            },
            iconValue: (id, record) => record.exchangeCode
          },
          {
            field: 'apsGroupId',
            filter: true,
            column: 2,
            type: TYPE.TEXT,
            leftButton: {
              icon: 'fa-solid fa-arrow-right',
              command: (record) => record.apsGroupId = this.formRecord.orderReference
            },
            input: (event, record) => {
              record.apsGroupId = record.apsGroupId.toUpperCase();
            },
            disabled: record => {
              return !this.apsManagement()
            }
          },

          {
            field: 'accountCode',
            // required: true,
            column: 2,
            type: TYPE.AUTOCOMPLETE,
            options: (record, query) => {
              if (query) {
                if (!record.accountCode || !record.accountCode.toLowerCase().includes(query.toLowerCase())) {
                  // record.accountCode = query;
                  queueMicrotask(() => this.forceAccountValues(record, query));
                } else {
                  record.accountCode = query;
                }
              }
              return this.getDistinctOpts(this.filterAccounts(record, query));
            },
            changed: (event, record) => {
              // if (event.select || this.autoFillCustomerAcct) {
                queueMicrotask(() => this.forceAccountValues(record, event.text));
              // }
              // if (record.accountCode != event.text
              //   && !record.accountCode.includes(event.text)) {
              //   record.accountCode = event.text;
              //   this.forceAccountValues(record);
              //   this.detectChanges();
              // }
            }
            // changed: (event, record) => {
            //   record.accountCode = event.text;
            //   if (record.accountCode && record.accountCode.length > 2) {
            //     const accountField = this.accounts.filter(field => record.clearingHouse === field.value.clearingHouse
            //       && (!field.value.exchangeCode || field.value.exchangeCode === ExchangeDetail.ALL || record.exchangeCode === field.value.exchangeCode))
            //       .find(field => field.text.toLowerCase().includes(record.accountCode.toLowerCase()));
            //     // console.log("----> record "+JSON.stringify(record))
            //     // console.log("----> accounts "+JSON.stringify(this.accounts.filter(field => field.value.exchangeCode==record.exchangeCode)))
            //     if (accountField) {
            //       record.accountCode = accountField.value.code;
            //       const accountDef = accountField.value;
            //       record.accountTypeCode = accountDef.accountTypeCode;
            //       record.giveupAccountType = accountDef.giveupAccountType;
            //       record.executionFee = accountDef.executionFee;
            //       record.giveUpBrokerCode = accountDef.giveUpBrokerCode;
            //       record.giveUpCommission = accountDef.giveUpCommission;
            //       record.giveUpMessage = accountDef.giveUpMessage ? accountDef.giveUpMessage.toUpperCase() : '';
            //       if (this.manageGiveUpMssg23(record)) {
            //         record.giveUpMessage2 = accountDef.giveupMessage2;
            //         record.giveUpMessage3 = accountDef.giveupMessage3;
            //       }
            //       record.broker = accountDef.giveupMessage3;
            //       record.openClose = accountDef.openCloseForFutures;
            //       record.reference1 = accountDef.reference1 ? accountDef.reference1.toUpperCase() : '';
            //       record.reference2 = accountDef.reference2;
            //       record.reference3 = accountDef.reference3;
            //       record.traderName = accountDef.traderName;
            //
            //       const customerField = this.displayedCustomers.find(customer => customer.id == '' + accountDef.customerId);
            //       if (customerField) {
            //         record.customerName = customerField.text;
            //         record.customerId = customerField.id;
            //         if (this.formRecord.customerId != customerField.id) {
            //           this.formRecord.customerName = customerField.text;
            //           this.formRecord.customerId = customerField.id;
            //           this.formRecord.allocations.forEach(allocation => {
            //             if (allocation.exchangeCode != record.exchangeCode) {
            //               allocation.accountTypeCode = AccountType.GIVE_UP_CODE;
            //               allocation.giveupAccountType = undefined;
            //               allocation.executionFee = undefined;
            //               allocation.giveUpBrokerCode = undefined;
            //               allocation.giveUpCommission = undefined;
            //               allocation.giveUpMessage = undefined;
            //               allocation.giveUpMessage2 = undefined;
            //               allocation.giveUpMessage3 = undefined;
            //               allocation.broker = undefined;
            //               allocation.openClose = OpenClose.NO;
            //               allocation.reference1 = undefined;
            //               allocation.reference2 = undefined;
            //               allocation.reference3 = undefined;
            //               allocation.traderName = undefined;
            //             }
            //           })
            //         }
            //       }
            //
            //     }
            //   }
            // }
          },
          {
            field: 'accountTypeCode',
            // required: true,
            filter: true,
            column: 1,
            type: TYPE.AUTOCOMPLETE,
            options: (record) => this.getDistinctOpts(this.displayedAccountTypes),
          },
          {
            column: 6,
            type: TYPE.NONE,
          }
        ]
      },
      {
        group: '',
        hidden: record => AccountType.GIVE_UP_CODE === record.accountTypeCode,
        fields: [
          {
            field: 'openClose',
            filter: true,
            column: 2,
            type: TYPE.DROPDOWN,
            options: () => this.openCloses,
            hidden: () => {
              const exchangeField = this.exchanges ? this.exchanges.find(value => value.id === this.formRecord.exchangeCode) : undefined;
              if (exchangeField) return !exchangeField.value.openCloseManagement;
              return false;
            }
          },
          {
            field: 'reference1',
            column: 2,
            type: TYPE.TEXT,
            input: (event, record) => {
              record.reference1 = record.reference1.toUpperCase();
            }
          },
          {
            field: 'reference2',
            column: 2,
            type: TYPE.TEXT,
            disabled: () => true
          },
          {
            field: 'reference3',
            column: 3,
            type: TYPE.TEXT
          },
          // {
          //   column: 2,
          //   type: TYPE.NONE
          // },
        ]
      },
      {
        group: '',
        hidden: record => AccountType.GIVE_UP_CODE != record.accountTypeCode,
        fields: [
          {
            field: 'giveUpBrokerCode',
            // required: true,
            column: 2,
            type: TYPE.TEXT
          },
          {
            field: 'giveUpMessage',
            // required: true,
            column: 2,
            type: TYPE.TEXT,
            input: (event, record) => {
              record.giveUpMessage = record.giveUpMessage.toUpperCase();
            }
          },
          {
            field: 'giveUpMessage2',
            column: 2,
            type: TYPE.TEXT,
            hidden: record => {
              return !this.manageGiveUpMssg23(record);
            }
          },
          {
            field: 'giveUpMessage3',
            column: 2,
            type: TYPE.TEXT,
            hidden: record => {
              return !this.manageGiveUpMssg23(record);
            }
          },
          {
            field: 'broker',
            column: 2,
            type: TYPE.TEXT,
            hidden: record => {
              return this.manageGiveUpMssg23()
            }
          },
          {
            field: 'giveupAccountType',
            filter: true,
            column: 1,
            type: TYPE.AUTOCOMPLETE,
            options: (record) => this.getDistinctOpts(this.displayedGUpAccountTypes),
          },
          // {
          //   column: 3,
          //   type: TYPE.NONE
          // },
          // {
          //   field: 'giveUpCommission',
          //   column: 1,
          //   type: TYPE.TEXT
          // }
        ]
      },
      {
        group: '',
        fields: [
          // {
          //   field: 'executionFee',
          //   column: 1,
          //   type: TYPE.TEXT
          // },
          // {
          //   field: 'moneyOwner',
          //   column: 1,
          //   type: TYPE.TEXT
          // },
          // {
          //   field: 'rate',
          //   column: 1,
          //   type: TYPE.INTEGER
          // },
          {
            field: 'currency',
            column: 1,
            type: TYPE.TEXT,
            input: (event, formRecord, inputField) => {
              var start = inputField.selectionStart;
              var end = inputField.selectionEnd;
              inputField.value = inputField.value.toUpperCase();
              formRecord.currency = inputField.value;
              inputField.setSelectionRange(start, end);
            },
          },
          {
            field: 'traderName',
            filter: true,
            column: 2,
            type: TYPE.AUTOCOMPLETE,
            options: (record) => this.getDistinctOpts(this.filterTraders(record)),
          },
        ]
      });
  }

  public open(selectedIds: string[], clearingSelectionInfos: ClearingSelectionInfo[]): void {
    let allocationInProgress: AllocationRequest = undefined;
    if (selectedIds && selectedIds.length > 0) {
      // this.significantTrades = significantTrades;

      if (!allocationInProgress) {
        allocationInProgress = new AllocationRequest();
        allocationInProgress.tradeIds = selectedIds;
        const addedClearingHouseExchanges: string[] = []
        clearingSelectionInfos.forEach(clearingSelectionInfo => {
          if (!addedClearingHouseExchanges.includes(clearingSelectionInfo.clearingHouse + "_" + clearingSelectionInfo.exchangeCode)) {
            const allocationSplit: AllocationSplitRequest = {
              clearingHouse: clearingSelectionInfo.clearingHouse,
              exchangeCode: clearingSelectionInfo.exchangeCode,
              accountTypeCode: AccountType.GIVE_UP_CODE
            };
            allocationInProgress.allocations.push(allocationSplit);
            addedClearingHouseExchanges.push(clearingSelectionInfo.clearingHouse + "_" + clearingSelectionInfo.exchangeCode);
          }
        });
        const clearingSelectionInfo = clearingSelectionInfos[0];
        allocationInProgress.owner = clearingSelectionInfo.owner;
        allocationInProgress.clearingHouse = clearingSelectionInfo.clearingHouse;
        allocationInProgress.exchangeCode = clearingSelectionInfo.exchangeCode;
        allocationInProgress.execTrader = clearingSelectionInfo.operatorId;
        allocationInProgress.accountTypeCode = AccountType.GIVE_UP_CODE;
        allocationInProgress.traderMemo = clearingSelectionInfo.freeText2;
        this.originTraderMemo = clearingSelectionInfo.freeText2;
        allocationInProgress['formContractsCodes'] = new Set(clearingSelectionInfos.map(value => value.contract));
        // const firstTrade = significantTrades[0];
        // // allocationInProgress.owner = firstTrade.owner;
        // allocationInProgress.clearingHouse = firstTrade.clearingHouse;
        // allocationInProgress.exchangeCode = firstTrade.exchangeCode;
        this.openWithRecord(allocationInProgress);
      }
    }
  }

  public openWithRecord(newFormRecord: AllocationRequest): void {
    this.formRecord = newFormRecord;
    this.formContractsCodes = newFormRecord['formContractsCodes'];
    this.loadData();
    // this.filterCustomers();
    // this.filterAccounts();
    // this.filterAccountTypes();
    this.loadFooterInfos(this.formRecord.tradeIds);
    this.ccFormDialog.reloadFieldValueMap();
    this.show();
  }

  protected doSave() {
    this.formLoading = true;
    this.formRecord.allocations.forEach(alloc => {
      if (this.manageGiveUpMssg23(alloc)) {
        alloc.broker = alloc.giveUpMessage3;
      }
    });
    this.allocationService.singleAllocationRequest(this.formRecord).subscribe(validation => {
      if (validation.success) {
        this.onSavedForm.emit({taskId: validation.item, formRecord: Object.assign({}, this.formRecord)});
        this.closeDialogForm();
      } else {
        this.errorMessage(validation.message);
      }
      this.formLoading = false;
    });
  }

  protected forceAccountValues(record, accountCode): Customer {
    const customer = super.forceAccountValues(record, accountCode);
    if (customer) {
      if (this.formRecord.customerId != customer.id) {
        this.formRecord.customerName = customer.code;
        this.formRecord.customerId = customer.id;
        this.formRecord.allocations.forEach(allocation => {
          if (allocation.exchangeCode != record.exchangeCode) {
            allocation.accountTypeCode = AccountType.GIVE_UP_CODE;
            allocation.accountCode = undefined;
            allocation.giveupAccountType = undefined;
            allocation.executionFee = undefined;
            allocation.giveUpBrokerCode = undefined;
            allocation.giveUpCommission = undefined;
            allocation.giveUpMessage = undefined;
            allocation.giveUpMessage2 = undefined;
            allocation.giveUpMessage3 = undefined;
            allocation.broker = undefined;
            allocation.openClose = OpenClose.NO;
            allocation.reference1 = undefined;
            allocation.reference2 = undefined;
            allocation.reference3 = undefined;
            allocation.traderName = undefined;
          }
        });
        this.ccFormDialog.reloadFieldValueMap();
        this.markForCheck();
      }
    }
    return customer;
  }

  protected getSelectionSummary(summaryRequest: ClearingInfoLoadRequest): Observable<ApiValidation<ClearingSelectionSummary[]>> {
    return this.clearingTradeInfoService.getSelectionSummary(summaryRequest);
  }
}
